/**
 * @generated SignedSource<<4c08d358f080b25d3b0a4b00188c9c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaselineTemplatesList_company$data = {
  readonly baselineTemplates: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly description: string | null;
    readonly includeDeliverables: boolean | null;
    readonly active: boolean | null;
    readonly usageCount: number | null;
    readonly phaseCount: number | null;
    readonly deliverableCount: number | null;
    readonly totalMinutes: number | null;
    readonly roleCount: number | null;
    readonly expenseLineCount: number | null;
    readonly updatedAt: string | null;
    readonly createdBy: {
      readonly id: string;
      readonly fullName: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "BaselineTemplatesList_company";
};
export type BaselineTemplatesList_company$key = {
  readonly " $data"?: BaselineTemplatesList_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaselineTemplatesList_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaselineTemplatesList_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineTemplate",
      "kind": "LinkedField",
      "name": "baselineTemplates",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includeDeliverables",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phaseCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deliverableCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expenseLineCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "a4cf3ff96bde5261972be403c6d50b00";

export default node;
